// import { useUserStore, useAuthStore } from "@/modules/auth/store/auth-store";
import { basicAuthHeader, bearerAuthHeader } from "./headers";
// import { toast } from "sonner";
// import { toast, ToastContainer } from "react-toastify";
import { REACT_APP_BASE_URL } from "../Components/processENV";
import { getFromLocalStorage } from "../Components/WebChat/WebChatEncryptDecrypt";

export const API_BASE_URL =
  REACT_APP_BASE_URL || "http://localhost:3000";

export let isAuthRedirected = false;

// Reset flag on page reload
if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", () => {
    isAuthRedirected = false;
  });
}

// Manually reset from app (e.g., after login)
export const setBearerRedirectedFlagFalse = () => {
  isAuthRedirected = false;
};

// 🔥 Handles session expiry, account deletion, or unauthorized access
// const handleAuthFailure = () => {
//   if (isAuthRedirected) return;

//   // Stop firing if already on login page
//   if (typeof window !== "undefined" && window.location.pathname === "/") return;

//   isAuthRedirected = true;

//   const clearAuth = useAuthStore.getState().clearAuthStore;
//   const clearUser = useUserStore.getState().clearStoreUser;

//   clearAuth();
//   clearUser();

//   localStorage.clear();

//   toast.error("Session expired. Please log in again.");
//   setTimeout(() => {
//     window.location.href = "/";
//   }, 1500);
// };

const getAuthToken = () => {
  const token = getFromLocalStorage("token");
  if(token){
    return token;
  }
  return null;
};

export const basicApiRequest = async (
  endpoint,
  method,
  body,
) => {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method,
      headers: basicAuthHeader(),
      body: body ? JSON.stringify(body) : undefined,
    });

    const responseData = await response.json();

    if (!response.ok) {
      if ([401, 403].includes(response.status)){;
      throw new Error(responseData.message || "Request failed");
      }
    }

    setBearerRedirectedFlagFalse();
    return responseData;
  } catch (error) {
    console.error("basicApiRequest error:", error);
    return null;
  }
};

export const bearerApiRequest = async (
  endpoint,
  method,
  body,
  baseUrl,
) => {

  try {
    // const { userData } = useUserStore.getState();
    const baseUrlToUse = baseUrl
    ? baseUrl
    : API_BASE_URL;

    // get token from redux store
    const tokenBearer = getAuthToken() || "";

    if(!tokenBearer){
      throw new Error("Token not found");
    }

    const response = await fetch(`${baseUrlToUse}${endpoint}`, {
      method,
      headers: bearerAuthHeader(tokenBearer),
      body: body ? JSON.stringify(body) : undefined,
    });

    const responseData = await response.json();

    if (!response.ok) {
      if ([401, 403].includes(response.status)) {
        // handleAuthFailure();
      }
      throw new Error(responseData.message || "Request failed");
    }

    setBearerRedirectedFlagFalse();
    return responseData;
  } catch (error) {
    console.error("bearerApiRequest error:", error);
    return null;
  }
};
